export default class Environment {
    public name: string = '';
    public application: string = '';
    public apiEndpoint: string = '';
    public reportApiEndpoint: string = '';
    public appInsightsConnectionString: string = '';
    public enableDebug: boolean = true;
    public theme?: string;

    constructor(object: Partial<Environment>, apex: string) {
        Object.assign(this, object);
        if (apex) {
            this.apiEndpoint = this.apiEndpoint.replace('{apex}', apex);
            this.reportApiEndpoint = this.reportApiEndpoint.replace('{apex}', apex);
        }
    }
}
